import React from 'react'; // eslint-disable-line
import Tooltip from 'rc-tooltip';

const HelpTooltip = (props) => {
    return (
        <span
            data-qa={`tooltip-wrapper-for-${props.dataqa}`}
            id={props.tooltipName}
            aria-label={props.tooltipText}
        >
            <Tooltip
                placement="bottom"
                trigger="[hover, focus]"
                mouseEnterDelay={0}
                mouseLeaveDelay={0.1}
                overlay={<span data-qa={`tooltip-text-for-${props.dataqa}`}>{props.tooltipText}</span>}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g transform="translate(-713.000000, -949.000000)">
                            <g transform="translate(713.000000, 949.000000)">
                                <circle fill="#979797" cx="5.5" cy="5.5" r="5.5" />
                                <path
                                    d="M4.998,6.912 C4.998,6.58799838 5.07149926,6.31950106 5.2185,6.1065 C5.36550074,5.89349893 5.57999859,5.66100126 5.862,5.409 C6.07800108,5.21699904 6.23849948,5.0505007 6.3435,4.9095 C6.44850053,4.76849929 6.501,4.6080009 6.501,4.428 C6.501,4.17599874 6.39900102,3.97200078 6.195,3.816 C5.99099898,3.65999922 5.71800171,3.582 5.376,3.582 C4.72799676,3.582 4.23900165,3.81299769 3.909,4.275 L3.036,3.708 C3.29400129,3.35399823 3.62699796,3.08250094 4.035,2.8935 C4.44300204,2.70449905 4.92299724,2.61 5.475,2.61 C6.14700336,2.61 6.682498,2.75549854 7.0815,3.0465 C7.480502,3.33750145 7.68,3.73799745 7.68,4.248 C7.68,4.49400123 7.6395004,4.70999907 7.5585,4.896 C7.47749959,5.08200093 7.38000057,5.23949935 7.266,5.3685 C7.15199943,5.49750064 7.00200093,5.64599916 6.816,5.814 C6.58799886,6.01800102 6.41850056,6.19799922 6.3075,6.354 C6.19649945,6.51000078 6.141,6.69599892 6.141,6.912 L4.998,6.912 Z M5.574,9.063 C5.36399895,9.063 5.19150068,8.99550067 5.0565,8.8605 C4.92149933,8.72549933 4.854,8.55900099 4.854,8.361 C4.854,8.16299901 4.92149933,7.99800066 5.0565,7.866 C5.19150068,7.73399934 5.36399895,7.668 5.574,7.668 C5.77800102,7.668 5.94749933,7.73399934 6.0825,7.866 C6.21750068,7.99800066 6.285,8.16299901 6.285,8.361 C6.285,8.55900099 6.21750068,8.72549933 6.0825,8.8605 C5.94749933,8.99550067 5.77800102,9.063 5.574,9.063 Z"
                                    id="?"
                                    fill="#FFFFFF"
                                    fillRule="nonzero"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            </Tooltip>
        </span>
    );
};

export default HelpTooltip;
